import React from 'react';
import { graphql, useFragment } from 'react-relay';
import type { TriggerPropsType } from '@atlassian/jira-issue-table-inline-issue-create/src/ui/index.tsx';
import type { firstColumnCell_nativeIssueTable$key } from '@atlassian/jira-relay/src/__generated__/firstColumnCell_nativeIssueTable.graphql';
import { ExpandButtonWithCreateChildButton } from '@atlassian/jira-issue-table-hierarchy/src/ui/expand-button/index.tsx';
import { useIsChildIssueCreateEnabled } from '../../../../controllers/features/selectors.tsx';
import { useRowContext } from '../../../rows/row-context/index.tsx';

export type Props = {
	isRowHoveredOrSelected: boolean;
	depth: number;
	itemsConnectionId: string;
	issueRef: firstColumnCell_nativeIssueTable$key;
	triggerProps?: TriggerPropsType;
	isFormVisible?: boolean;
};

/**
 * @deprecated should be removed when jira_list_merged_column_gate is cleaned up
 */
const FirstColumnCell = ({
	isRowHoveredOrSelected,
	itemsConnectionId,
	depth,
	issueRef,
	triggerProps,
	isFormVisible,
}: Props) => {
	const issueData = useFragment<firstColumnCell_nativeIssueTable$key>(
		graphql`
			fragment firstColumnCell_nativeIssueTable on JiraIssueEdge
			@argumentDefinitions(
				projectKeys: { type: "[String!]" }
				projectKey: { type: "String" }
				shouldQueryHasChildren: { type: "Boolean!" }
				isJscM2Enabled: {
					type: "Boolean!"
					provider: "@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider"
				}
			) {
				hasChildren(filterByProjectKeys: $projectKeys)
					@include(if: $shouldQueryHasChildren)
					@optIn(to: "JiraSpreadsheetComponent-M2")
				canHaveChildIssues(projectKey: $projectKey)
					@include(if: $shouldQueryHasChildren)
					@optIn(to: "JiraSpreadsheetComponent-M2")
				node @include(if: $isJscM2Enabled) {
					issueId
				}
			}
		`,
		issueRef,
	);

	const { hasChildren, canHaveChildIssues } = issueData;
	const { issueId } = issueData.node ?? {};
	const { groupId } = useRowContext();

	const isChildIssueCreateEnabled = useIsChildIssueCreateEnabled();
	const showCreateChildButton =
		isChildIssueCreateEnabled && isRowHoveredOrSelected && Boolean(canHaveChildIssues);

	return (
		issueId && (
			<ExpandButtonWithCreateChildButton
				itemId={issueId}
				itemsConnectionId={itemsConnectionId}
				depth={depth}
				hasChildren={Boolean(hasChildren)}
				showCreateChildButton={showCreateChildButton}
				isRowHoveredOrSelected={isRowHoveredOrSelected}
				isCreateChildFormVisible={isFormVisible}
				createChildTriggerProps={triggerProps}
				groupId={groupId}
			/>
		)
	);
};

export default FirstColumnCell;
